import userServices from './user';

export const isAuthenticated = () => {
  return userServices.isLoggedIn();
};

export const isAdmin = () => {
  return userServices.getEmail().endsWith('rootine.co');
};

export const logout = () => {
  userServices.logOut();
};
